var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteRequested(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 127.287,
    height: 150.066,
    viewBox: "0 0 127.287 150.066",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_64_1",
    "data-name": "Component 64 \\u2013 1",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7336",
    "data-name": "Path 7336",
    d: "M61.458,14.293a17.025,17.025,0,0,0-.759,5.042,5.7,5.7,0,0,0,5.695,5.695h34.169a5.7,5.7,0,0,0,5.695-5.695,17.084,17.084,0,0,0-.759-5.042m-44.04,0A17.092,17.092,0,0,1,77.783,2.25h11.39A17.088,17.088,0,0,1,105.5,14.293m-44.04,0q-4.283.262-8.535.607a16.53,16.53,0,0,0-15,16.644V47.809M105.5,14.293q4.283.262,8.535.607a16.53,16.53,0,0,1,15,16.644v78.908a17.085,17.085,0,0,1-17.085,17.085H94.868M37.919,47.809H12.292A8.545,8.545,0,0,0,3.75,56.351v85.423a8.545,8.545,0,0,0,8.542,8.542H86.325a8.545,8.545,0,0,0,8.542-8.542V127.537M37.919,47.809H86.325a8.545,8.545,0,0,1,8.542,8.542v71.186M32.224,104.757l11.39,11.39L66.393,87.673",
    transform: "translate(-3.75 -2.25)",
    fill: "none",
    stroke: "#807ce0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteRequested);
export default __webpack_public_path__ + "static/media/quote-requested.e4ca398acc41ba3e1794fc2c1168dda0.svg";
export { ForwardRef as ReactComponent };